import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const RouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return RouterPush.call(this, to).catch(err => err)
}
const routes = [
  // { path: '/login', name: 'login', component: () => import('@/views/login') },
  {
    path: '/',
    name: "home",
    component: () => import('@/views/home'),
    redirect: '/',
    children: [{
      path: '/',
      name: '',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: () => import('@/views/main'),
    }, {
      path: '/details',
      name: 'details',
      meta: {
        title: '百科在线-国家知识服务融合出版平台',
      },
      component: () => import('@/views/details'),

    },
    {
      path: '/header_pers',
      name: 'header_pers',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: () => import('@/views/details/components/destails/header_pers'),
    },
    {
      path: '/contribution',
      name: 'contribution',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: resolve => require(['@/views/contribution/contribution'], resolve),
    },
    {
      path: '/perfectInformation',
      name: 'perfectInformation',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: resolve => require(['@/views/perfectInformation/index'], resolve),
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: () => import('@/views/search'),
    }, {
      path: '/paperds',
      name: 'paperds',
      meta: {
        title: '百科在线-国家知识服务融合出版平台'
      },
      component: () => import('@/views/paperds/paperds'),
    },
    {
      path: '/classify',
      name: 'classify',
      meta: {
        title: '百科在线-国家知识服务融合出版平台',
        keepAlive: true
      },
      component: () => import('@/views/classify'),
    }],
  },
]
const router = new Router({
  routes,
  mode: 'history',
  // base: '/test'
})
export default router
